import { mdsCommunicationActions } from './constant';
import { MdsSignType } from 'src/services/apiServices/mdsCommunication/mds-comminication-service';

export const getMdsFormIdAction = (patientId: string, param: object) => {
  return {
    type: mdsCommunicationActions.REQUEST_GET_FORM_ID,
    patientId,
    param,
  };
};

export const resetMdsFormIdAction = () => {
  return {
    type: mdsCommunicationActions.RESET_GET_FORM_ID,
  };
};

export const getAllMdsFormAction = (patientId: SVGStringList, params: object) => {
  return {
    type: mdsCommunicationActions.REQUEST_GET_ALL_MDS_FORM,
    patientId,
    params,
  };
};

export const signMdsFormAction = (mdsFormId: string) => {
  return {
    type: mdsCommunicationActions.REQUEST_SIGN_MDS_FORM,
    mdsFormId,
  };
};

export const resetSignMdsFormAction = () => {
  return {
    type: mdsCommunicationActions.RESET_SIGN_MDS_FORM,
  };
};

export const addSignerToMdsFormAction = (payload: MdsSignType) => {
  return {
    type: mdsCommunicationActions.REQUEST_ADD_SIGNER_TO_MDS_FORM,
    payload,
  };
};

export const resetaddSignerToMdsFormAction = () => {
  return {
    type: mdsCommunicationActions.RESET_ADD_SIGNER_TO_MDS_FORM,
  };
};

export const getMdsFormByIdAction = (mdsFormId: string) => {
  return {
    type: mdsCommunicationActions.REQUEST_GET_MDS_FORM_BY_ID,
    mdsFormId,
  };
};

export const getMdsTypeAction = (patientId: string) => {
  return {
    type: mdsCommunicationActions.REQUEST_GET_MDS_TYPE,
    patientId,
  };
};

export const getMdsReformId = (patientId: string) => {
  return {
    type: mdsCommunicationActions.REQUEST_GET_MDS_REFORM_ID,
    patientId,
  };
};

export const resetMdsReformId = () => {
  return {
    type: mdsCommunicationActions.RESET_GET_MDS_REFORM_ID,
  };
};
